$.fn.ReadMore = function() {
  let self = this

  if (self.data('read-more')) {
    return self.data('read-more')
  }

  self.button = self.find('button')
  self.content = self.parent()
  self.max_height = 0
  self.target_height = 0

  self.calculate = function() {
    self.content.css({
      'max-height': '',
      'overflow': '',
    })
    self.target_height = self.content.outerHeight(false)
    self.max_height = self.button.offset().top - self.content.offset().top + self.outerHeight(false) + 1
    self.content.css({
      'position': 'relative',
      'max-height': self.max_height + 'px',
      'overflow': 'hidden',
    })
  }

  self.expand = function() {
    self.button.attr('aria-expanded', 'true')
    self.content.animate({
      'max-height': self.target_height + 'px',
    }, 500, 'easeInOutQuart', function() {
      self.content.css({
        'max-height': '',
        'overflow': '',
      })
      $(window).off('load orientationchange resize', self.calculate)
      self.remove()
    })
  }

  return function() {
    $(window).on('load orientationchange resize', self.calculate)
    self.calculate()
    self.button.on('click', self.expand)
    self.data('read-more', self)
    return self
  }()
}
